import { createSlice } from '@reduxjs/toolkit';
import { clearReducers } from 'redux/logout';

export const initialState = {
  items: {},
  search: '',
  pageable: {
    pageNumber: 0,
    pageSize: 10,
  },
  loaded: false,
};

const marketplaceSlice = createSlice({
  name: 'marketplaces',
  initialState,
  reducers: {
    initial: () => {},
    fetch: (state) => {
      state.loaded = false;
    },
    deleteSuccess: (state, action) => {
      state.items = state.items.filter((item) => item.id === action.payload);
    },
    success: (state, action) => {
      state.loaded = true;
      action.payload.forEach((marketplace) => {
        state.items[marketplace.id] = marketplace;
      });
    },
    failure: (state) => {
      state.loaded = true;
    },
    updatePageable: (state, action) => {
      state.pageable.pageNumber =
        action.payload.pageSize !== state.pageable.pageSize
          ? 0
          : action.payload.pageNumber;
      state.pageable.pageSize = action.payload.pageSize;
    },
    updateSearch: (state, action) => {
      state.pageable.pageNumber = 0;
      state.search = action.payload;
    },
    delete: (state) => {
      state.loaded = false;
    },
    resetFilters: (state) => {
      state.search = initialState.search;
      state.pageable = initialState.pageable;
    },
    refreshPage: (state) => {
      state.items = {};
      state.loaded = false;
    },
  },
  extraReducers: {
    [clearReducers]: () => initialState,
  },
});

export const { name, reducer, actions } = marketplaceSlice;
